import { withChartLayout } from 'components/common';
import Elimination from 'components/features/chart/basic-nursing-care/elimination/Elimination';

const EliminationPage = withChartLayout('Elimination')(Elimination);
export default EliminationPage;
